import { useFetchCompany, useGetCompanySummary } from "../../api/admin/company";
import { isS2dUser } from "../../auth/userAccessHelpers";
import { UseFormReturn } from "react-hook-form";
import { AddDriverFormValues } from "./AddDriverFormValues";
import { useEffect } from "react";
import { DriverValidationTypes } from "../../models/app/admin/company";
import useAuth from "../../auth";

export const useAddDriverCompanyInformation = (
    methods: UseFormReturn<AddDriverFormValues>
) => {
    const user = useAuth();
    const { companySummary, isLoadingCompanySummary } = useGetCompanySummary();

    const userCompanyId = user.userDetails?.companyId ?? null;
    const isClientUser = !isS2dUser(user.decodedToken?.role);

    // company id will be automatically set to the user's company
    // unless the user is an s2d member and has no associated company.
    useEffect(() => {
        if (isClientUser) {
            methods.setValue("companyId", userCompanyId);
        }
    }, [userCompanyId]);

    const { fetchCompany } = useFetchCompany();

    const updateDriverIdentityValidationType = async (
        id: string | undefined
    ) => {
        if (id) {
            const response = await fetchCompany(id);

            if (response.success) {
                const validationType =
                    response.content.settings.edeclaration
                        ?.driverValidationType;

                if (validationType) {
                    methods.setValue(
                        "validateDriverIdentityBy",
                        validationType ?? DriverValidationTypes.DateOfBirth
                    );
                }
            }
        }
    };

    // for users with an associate client, companyValidationPreference should be automatically set to that client's preference.
    // this will be ignored for s2d users.
    useEffect(() => {
        if (isClientUser) {
            updateDriverIdentityValidationType(userCompanyId ?? undefined);
        }
    }, [userCompanyId]);

    return {
        companySummary,
        isLoadingCompanySummary,
        isClientUser,
    };
};
